(() => {
  if (window.ShrineDescriptionCleanupV1) return;
  window.ShrineDescriptionCleanupV1 = true;

  const scopeSelector = [
    '.em-product-tabs__panel--description',
    '.product__description',
    '.collection-hero__description'
  ].join(',');

  const junkSelector = [
    '.button-container.hide-from-message-actions',
    '.container.hide[class*="ng-tns-"]',
    '.carousel-container',
    '.carousel-content',
    '.sources-carousel-source',
    '[data-test-id="sources-carousel-source"]'
  ].join(',');

  const visualSelector = 'img, svg, picture, video, iframe, canvas';

  const hasVisibleContent = (element) => {
    const text = (element.textContent || '').replace(/\u00a0/g, ' ').trim();
    return text.length > 0 || Boolean(element.querySelector(visualSelector));
  };

  const cleanScope = (scope) => {
    scope.querySelectorAll(junkSelector).forEach((element) => element.remove());

    scope.querySelectorAll('button.button').forEach((button) => {
      if (!hasVisibleContent(button)) button.remove();
    });

    scope.querySelectorAll('sup.superscript').forEach((element) => {
      if (!hasVisibleContent(element)) element.remove();
    });

    scope.querySelectorAll('p').forEach((paragraph) => {
      if (!hasVisibleContent(paragraph)) paragraph.remove();
    });
  };

  const run = (root = document) => {
    if (root.matches?.(scopeSelector)) cleanScope(root);
    root.querySelectorAll?.(scopeSelector).forEach(cleanScope);
  };

  const boot = () => run(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
